import { render, staticRenderFns } from "./ExchangeForm.vue?vue&type=template&id=19fc258b&"
import script from "./ExchangeForm.vue?vue&type=script&lang=js&"
export * from "./ExchangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports